export default "__VITE_ASSET__oNKIY6sV__";